export default __webpack_public_path__ + "static/tree-3-859f1e935a6730e4bfa7824b24f5c64b.webp";